import {Avatar, Input} from 'antd'
import {auth_fetchOrganizationsWithAdminAuth_Api, auth_updateOrg_Api,} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {LoginContext} from 'components/LoginContext'
import getAvatar from 'helpers/getAvatar'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import React, {useContext, useState,} from 'react'
import EntityList from 'views/AppLocals/EntityList'
import {useDeBounceValue} from 'views/Search/useDeBounceValue'
import {NullAsDefault, renderFalse} from 'views/Shared'
import {BiSolidChurch} from "react-icons/bi";
import {OrgType} from "../../AppLocals/Organization/components/OrgType";
import {PiChecksBold} from "react-icons/pi";
import WorkspaceContext from "../WorkspaceContext";
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import _ from "lodash";
import {NotificationActionTypes} from "../../AppLocals/factory/createNotification";
import {getRouteSearchParams} from "../../../envs/_current/history";
import {notifyOnError} from "../../AppLocals/factory/createErrorEvent";
import {useRouterSearchParam} from "../../../modules/navigation/useOnLocationChange";
import {successMessage} from "../../AppLocals/factory/createMessageNotification";

export const WorkspaceAvatar = ({src, style, onClick, ...props}) => (
    <Avatar
        src={src}
        style={style}
        onClick={onClick}
        {...props}
    />
)

const excludedKeys = {
    all: '__workspace_picker_more__',
}

const renderOrganizationRow = ({translate: t, onItemSelected = NullAsDefault, isSelected = renderFalse}) => (item) => {
    const id = getId(item)
    const selected = !!isSelected(id)

    return (
        <div
            key={id}
            onClick={() => {
                if (!selected) onItemSelected(item)
            }}
            className={classNames(
                'p-3 flex items-center gap-3 custom-item-render',
                !selected
                    ? 'font-semibold text-gray-800 list-item cursor-pointer'
                    : 'font-bold text-secondary-600 bg-secondary-50'
            )}>
            <WorkspaceAvatar
                size={42}
                className="flex flex-center bg-primary-50 shadow-md rounded-xl flex-shrink-0"
                src={getAvatar(item)}
                icon={<BiSolidChurch size={22} className="text-primary-400"/>}
            />
            <div className="flex flex-col flex-1 min-w-0">
                <div className="text-sm max-lines-1 tracking-wide">
                    {getTitle(item)}
                </div>
                <OrgType item={item} className="font-medium text-xs text-blue-500 tracking-wider"/>
            </div>
            {selected ? (
                <div className="px-3 flex flex-center text-secondary-600">
                    <PiChecksBold size={22}/>
                </div>
            ) : (
                <div
                    style={{ padding: '0.25rem 0.65rem', fontSize: 12 }}
                    className="font-semibold text-primary-600 hover:text-primary bg-primary-50 rounded-full leading-tight transition-colors contextIcon">
                    {t('select')}
                </div>
            )}
        </div>
    )
}

export const AdminOrganizations = () => {
    const t = useTranslate()
    const {onChangeSearchParams} = useRouterSearchParam({});
    const {setCurrent, handleGoBack = NullAsDefault} = useContext(NavigationContext)
    const {organization} = useContext(WorkspaceContext)
    const login = useContext(LoginContext)
    const primary_id = getId(organization)
    const {isLoading, handleAsyncAction: updateDefaultOrg} = useAsyncAction({
        apiInfo: auth_updateOrg_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            successMessage(NotificationActionTypes.UPDATE, t)
            const _searchParams = getRouteSearchParams();
            const _searchParamObj = Object.fromEntries(_searchParams.entries());

            if (!!dataItem?.primary_org) {
                _searchParamObj.org_id = getId(dataItem?.primary_org) || dataItem?.primary_org;
                onChangeSearchParams(_searchParamObj);
            }
        },
        onError: notifyOnError(t),
    })

    const onItemSelected = (item) => {
        const result = getId(item)
        updateDefaultOrg({organization_id: item?.id})
        setCurrent({
            key: excludedKeys.all,
            value: result,
        })
        // handleGoBack()
    }

    const [keyword, setKeyword] = useState()

    const debouncedValue = useDeBounceValue(keyword, 500)

    return (
        <div className="flex flex-col gap-3 mb-4">
            <Input.Search
                allowClear={true}
                placeholder={t('keyword')}
                onChange={(event) => {
                    setKeyword(event.target.value)
                }}
                className="input-search-with-icon"
            />
            <div className="flex flex-col divide-y divide-gray-100 list-item-workspace">
                <EntityList
                    key={debouncedValue}
                    values={{
                        keyword: debouncedValue,
                        filter_group: 'admin'
                    }}
                    apiInfo={auth_fetchOrganizationsWithAdminAuth_Api}
                    RenderEntity={React.Fragment}
                    renderItem={renderOrganizationRow({
                        translate: t,
                        onItemSelected,
                        isSelected: (id) => id === primary_id,
                    })}
                />
            </div>
        </div>
    )
}


export default AdminOrganizations
